import React from "react";
import { useFetchAllUsersQuery } from "@diditusa/shared/api/userApi";
import { Box, Button, Typography, Avatar } from "@mui/material";
import BasicTable from "@diditusa/shared/web_components/BasicTable/BasicTable";
import { BasicTableHeader, User } from "@diditusa/shared/types/commonTypes";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const navigate = useNavigate();
  const { data: users, error, isLoading, isError } = useFetchAllUsersQuery();

  if (isLoading) {
    return <p>Loading users...</p>;
  }

  if (isError) {
    return <p>Error: {error.toString() || "Failed to fetch users"}</p>;
  }

  const onRowClick = (idx: number) => {
    if (!users) {
      return;
    }

    const usr = users[idx];

    navigate(`/users/${usr.id}`);
  };

  const getCustomComponentForCell = (field: UserKey, idx: number) => {
    if (!users) {
      return;
    }
    const c = users[idx];
    if (field === "imageUrl") {
      return c.imageUrl ? (
        <Avatar src={c.imageUrl} alt={c.firstName} sx={{ mr: 2 }} />
      ) : (
        <PersonIcon />
      );
    }

    if (field === "phoneNumber") {
      return (
        <Button variant="outlined" sx={{ borderRadius: 5 }}>
          {c.phoneNumber}
        </Button>
      );
    }
  };

  type UserKey = keyof User;

  const headers: BasicTableHeader<UserKey>[] = [
    { key: "imageUrl", value: "" },
    { key: "firstName", value: "First Name" },
    { key: "lastName", value: "Last Name" },
    { key: "email", value: "Email" },
    { key: "phoneNumber", value: "Phone Number" },
    { key: "createdAt", value: "Joined" },
  ];
  const data: User[] = users || [];
  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
      <Box sx={{ p: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h4" fontWeight="bold">
            Users
          </Typography>
          <Button
            variant="contained"
            color="inherit"
            sx={{ borderRadius: 10 }}
            // onClick={}
          >
            Invite new users
          </Button>
        </Box>
        <BasicTable
          headers={headers}
          data={data}
          getCustomComponentForField={getCustomComponentForCell}
          onRowClick={onRowClick}
        />
      </Box>
    </Box>

    // <div>
    //   <h1>Users</h1>
    //   <Box>
    //     <LoadingIndicator isVisible={syncUsersState.isLoading} />
    //     <Button onClick={() => syncUsersFromCognito()}>
    //       Sync Cognito users
    //     </Button>
    //   </Box>
    //   <table>
    //     <thead>
    //       <tr>
    //         <th>ID</th>
    //         <th>Email</th>
    //         <th>First Name</th>
    //         <th>Last Name</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {users &&
    //         users.map((user) => (
    //           <tr key={user.id}>
    //             <td>{user.id}</td>
    //             <td>{user.email}</td>
    //             <td>{user.firstName}</td>
    //             <td>{user.lastName}</td>
    //           </tr>
    //         ))}
    //     </tbody>
    //   </table>
    // </div>
  );
};

export default Users;
